import { FC } from 'react'
import {
  DefaultFormContainer,
  AddressOptions,
  DateRangeContainer
} from './styles'
import OptionButton from '../../basic/OptionButton'
import { LeftBar } from '../../../components/basic/LeftBar';
import StandardFormatInput from '../../../components/basic/StandardFormatInput';
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage';

interface OptionDateRangeProps {
  title: string;
  subtitle: string;
  showOptions?: boolean;
  from?: string;
  setFrom: (text: string | undefined) => void;
  to?: string;
  setTo: (text: string | undefined) => void;
  selectedOption?: boolean;
  setSelectedOption?: (option: boolean) => void;
  errorCodes?: string[]
}

const OptionDateRange: FC<OptionDateRangeProps> = ({
  title,
  subtitle,
  showOptions,
  from,
  setFrom,
  to,
  setTo,
  selectedOption,
  setSelectedOption,
  errorCodes = ['']
}) => {
  const handleOptionButton = (option: boolean) => {
    if (!!setSelectedOption) {
      setSelectedOption(option)
      if(!option) {
        //setText('')
      }
    }
  }

  return (
    <DefaultFormContainer>
      <strong>{title}</strong>
      {showOptions ? (
        <AddressOptions>
          <OptionButton
            checked={selectedOption === true}
            onChange={() => handleOptionButton(true)}
            errorCode={errorCodes[0]}
          >
            Yes
          </OptionButton>
          <OptionButton
            checked={selectedOption === false}
            onChange={() => handleOptionButton(false)}
            errorCode={errorCodes[0]}
          >
            No
          </OptionButton>
        </AddressOptions>
      ) : null}
      <ValidationErrorMessage errorCode={errorCodes[0]} />
      {(!showOptions || (showOptions === true && selectedOption === true)) ? (
        <DateRangeContainer>
          <LeftBar />
          <div className='date-range-content'>
            <strong>{subtitle}</strong>
            <div className='date-range-inputs'>
              <StandardFormatInput
                label="From"
                labelSize='small'
                maskStyle='monthYear'
                leftIcon='calendar'
                value={from}
                onValueChange={({formattedValue}) => setFrom(formattedValue)}
                errorCode={errorCodes[1]}
              />
              <StandardFormatInput
                label="To"
                labelSize='small'
                maskStyle='monthYear'
                leftIcon='calendar'
                value={to}
                onValueChange={({formattedValue}) => setTo(formattedValue)}
                errorCode={errorCodes[2]}
              />
            </div>
          </div>
        </DateRangeContainer>
      ) : null}
    </DefaultFormContainer>
  )
}

export default OptionDateRange